import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Close } from '@material-ui/icons'
import { Alert, CleanButton, Label, Loader, PrimaryButton, SelectField } from '../default'
import { Box, Grid, IconButton, Modal, Paper, Tooltip, withStyles } from '@material-ui/core'
import { connect, useDispatch } from 'react-redux'
import { acClearUpdateCustomerData, acGetPlanTables, acPutUpdateCustomer } from '../../class/actions'


function CustomerPlanTableModal({
  classes, open, onClose, onRefresh,
  currentCustomer,
  planTablesError, loadingPlanTables, planTables,
  updatingCustomer, errorUpdateCustomer, successUpdateCustomer
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [selectedPlanTable, setSelectedPlanTable] = useState('')

  useEffect(() => {
    if (currentCustomer && currentCustomer.plan_table_id && !selectedPlanTable)
      setSelectedPlanTable(currentCustomer.plan_table_id)
  }, [currentCustomer, selectedPlanTable])

  useEffect(() => {
    if (!updatingCustomer && !errorUpdateCustomer && successUpdateCustomer) {
      dispatch(acClearUpdateCustomerData())
      onRefresh()
    }
  }, [dispatch, onRefresh, updatingCustomer, errorUpdateCustomer, successUpdateCustomer])

  useEffect(() => {
    dispatch(acGetPlanTables())
  }, [dispatch])

  const moveCustomerPlanTable = () => {
    dispatch(acPutUpdateCustomer(currentCustomer.id, {
      plan_table_id: selectedPlanTable
    }))
  }

  return (
    <Modal open={open} onClose={onClose} disableAutoFocus style={{ outline: 0 }}>
      <Paper
        square={true}
        className={classes.root + ' ' + classes.modalDiv}
      >
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Grid container spacing={2} className={classes.grid}>
            <Grid item xs={8}>
              <Label v='h6'>
                {t('modals.planTable.move.title')}
              </Label>
            </Grid>
            <Grid item xs={4} style={{ textAlign: 'right', padding: 0 }}>
              <Tooltip title={t('default.close')}>
                <IconButton onClick={onClose}>
                  <Close />
                </IconButton>
              </Tooltip>
            </Grid>
            <Grid item xd={12}>
              <Label>
                {t('modals.planTable.move.caption')}
              </Label>
            </Grid>
            <Grid item xs={12}>
              {
                loadingPlanTables ?
                  <Loader /> :
                  planTablesError ?
                    <Alert style={{ marginBottom: '15px' }} noMargin color="error" text={planTablesError.description ? planTablesError.description : t('modals.planTable.move.unknownError')} /> :
                    <SelectField id='select-customer-plan-table'
                      label={t('modals.planTable.move.planTable')}
                      items={planTables.map(planTable => ({
                        name: planTable.name,
                        value: planTable.plan_table_id
                      }))}
                      value={selectedPlanTable}
                      onChange={e => setSelectedPlanTable(e.target.value)} />
              }
            </Grid>
            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <CleanButton onClick={onClose} style={{ marginRight: '15px' }}>
                {t('default.cancel')}
              </CleanButton>
              <PrimaryButton onClick={moveCustomerPlanTable}>
                {
                  updatingCustomer ? (
                    <Loader />
                  ) : (
                    <div>
                      {t('modals.planTable.move.action')}
                    </div>
                  )
                }
              </PrimaryButton>
            </Grid>
            {
              errorUpdateCustomer &&
              <Grid item xs={12}>
                <Alert style={{ marginBottom: '15px' }} noMargin color="error" text={errorUpdateCustomer.description ? errorUpdateCustomer.description : t('modals.planTable.move.unknownError')} />
              </Grid>
            }
          </Grid>
        </Box>
      </Paper>
    </Modal >
  )
}

CustomerPlanTableModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  close: PropTypes.func
}

CustomerPlanTableModal.defaultProps = {
  open: false,
  onClose: () => true,
  close: () => true
}

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    padding: theme.spacing(2),
    maxHeight: '90%',
    overflowY: 'scroll'
  },
  grid: {
    display: 'flex',
    flex: 1
  },
  modalDiv: {
    [theme.breakpoints.up('md')]: {
      width: '35%'
    },
    width: '100%',
    top: '10%',
    left: '50%',
    transform: 'translate(-50%, -10%)',
  },
})

const mapStateToProps = ({ ReducerPlanTable, ReducerCustomer }) => ({
  planTables: ReducerPlanTable.planTables,
  planTablesError: ReducerPlanTable.planTablesError,
  loadingPlanTables: ReducerPlanTable.loadingPlanTables,

  updatingCustomer: ReducerCustomer.updatingCustomer,
  errorUpdateCustomer: ReducerCustomer.errorUpdateCustomer,
  successUpdateCustomer: ReducerCustomer.successUpdateCustomer
})

export default connect(mapStateToProps)(withStyles(styles)(CustomerPlanTableModal))